// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1663942627523
      var cssReload = require("/Users/ienache/Projects/BENLOLA TEAM/Benlola Team Projects/Remote/blueseedling.com/wp-content/themes/blueseedling/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"publicPath":"../","hmr":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  